import React, { useState, useEffect, useContext, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { AuthContext } from '../../../Header/auth - context';
import { useSelector } from 'react-redux';
import BonusiTab from './ObracunTuraTabs/BonusiTab';
import KilometriTab from './ObracunTuraTabs/KilometriTab';
import DnevniceObracunTab from './ObracunTuraTabs/DnevniceObracunTab';
import MinimalnaZaradaTab from './ObracunTuraTabs/MinimalnaZaradaTab';
import AdminZabraneTab from './ObracunTuraTabs/AdminZabraneTab';
import AmortizacijaTab from './ObracunTuraTabs/AmortizacijaTab';
import ObracunPlateZaglavljeTab from './ObracunTuraTabs/ObracunPlateZaglavljeTab';

const ObracunTuraHome = () => {
  const { t } = useTranslation();
    const toast = useRef(null);
    const auth = useContext(AuthContext);
    const company = useSelector(state => state.company);
    const user = useSelector(state => state.user);
    const activeClass = 'activeButton';
    const [changeView, setChangeView] = useState(1);

    const [options, setOptions] = useState({
        ValuteDB: [],
        VrsteVozilaDB: [],
        TipoviVozacaDB: [],
        TipDnevniceDB: [],
        DrzaveDB: [],
    });
    const [bonusiDB, setBonusiDB] = useState([]);
    const [kilometriDB, setKilometriDB] = useState([]);
    const [dnevniceDB, setDnevniceDB] = useState([]);
    const [minimalnaZaradaDB, setMinimalnaZaradaDB] = useState([]);
    const [zaposleniDB, setZaposleniDB] = useState([]);
    const [adminZabraneDB, setAdminZabraneDB] = useState([]);
    const [amortizacijaDB, setAmortizacijaDB] = useState([]);
    const [zaglavljeStavkeDB, setZaglavljeStavkeDB] = useState([]);
    const [zaglavljeValuteDB, setZaglavljeValuteDB] = useState([]);
    const [zaglavljeNacinDB, setZaglavljeNacinDB] = useState([]);
    const [zaglavljeTipDB, setZaglavljeTipDB] = useState([]);
    const [loadingInit, setLoadingInit] = useState(true);

    const fetchZaglavljeInit = () => {
        fetch(process.env.REACT_APP_BACKEND_URL + '/finance/ManageObracunPlateZaglavlje', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
            body: JSON.stringify({ step: 'INIT' }),
        })
            .then(res => res.json())
            .then(data => {
                setZaglavljeStavkeDB(data.StavkeDB || []);
                setZaglavljeValuteDB(data.ValuteDB || []);
                setZaglavljeNacinDB(data.NacinRacunanjaDB || []);
                setZaglavljeTipDB(data.TipTransakcijeDB || []);
            })
            .catch(err => console.error('ZaglavljeInit error:', err));
    };

    const fetchInit = () => {
        fetch(process.env.REACT_APP_BACKEND_URL + '/trip/ManageObracunSifarnik', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
            body: JSON.stringify({ step: 'INIT' }),
        })
            .then(res => res.json())
            .then(data => {
                const parsed = JSON.parse(data[0]['']);
                setOptions({
                    ValuteDB: parsed.ValuteDB || [],
                    VrsteVozilaDB: parsed.VrsteVozilaDB || [],
                    TipoviVozacaDB: parsed.TipoviVozacaDB || [],
                    TipDnevniceDB: parsed.TipDnevniceDB || [],
                    DrzaveDB: parsed.DrzaveDB || [],
                });
                setBonusiDB(parsed.BonusiDB || []);
                setKilometriDB(parsed.KilometriDB || []);
                setDnevniceDB(parsed.DnevniceDB || []);
                setMinimalnaZaradaDB(parsed.MinimalnaZaradaDB || []);
                setZaposleniDB(parsed.ZaposleniDB || []);
                setAdminZabraneDB(parsed.AdminZabraneDB || []);
                setAmortizacijaDB(parsed.AmortizacijaDB || []);
                setLoadingInit(false);
            })
            .catch(err => {
                console.error('ObracunTuraHome INIT error:', err);
                toast.current.show({ severity: 'error', summary: t('admin.m_greska_pri_ucitavanju_sifarnika'), life: 3000 });
                setLoadingInit(false);
            });
    };

    useEffect(() => {
        fetchInit();
        fetchZaglavljeInit();
    }, [changeView]); // eslint-disable-line react-hooks/exhaustive-deps

    if (loadingInit) return <div style={{ padding: '2rem' }}>{t('common.loading')}</div>;

    return (
        <div style={{ marginTop: '1%' }}>
            <Toast ref={toast} />
            <Button id={changeView === 1 && activeClass} label={t('ture.bonusi')} className="mt-3 zaposleniShift adminTab" onClick={() => setChangeView(1)} />
            <Button id={changeView === 2 && activeClass} label={t('admin.predjeniKm')} className="mt-3 zaposleniShift adminTab" onClick={() => setChangeView(2)} />
            <Button id={changeView === 3 && activeClass} label={t('ture.dnevnice')} className="mt-3 zaposleniShift adminTab" onClick={() => setChangeView(3)} />
            <Button id={changeView === 4 && activeClass} label={t('admin.minimalnaZarada')} className="mt-3 zaposleniShift adminTab" onClick={() => setChangeView(4)} />
            <Button id={changeView === 5 && activeClass} label={t('admin.adminZabrane')} className="mt-3 zaposleniShift adminTab" onClick={() => setChangeView(5)} />
            <Button id={changeView === 6 && activeClass} label={t('admin.amortizacija')} className="mt-3 zaposleniShift adminTab" onClick={() => setChangeView(6)} />
            <Button id={changeView === 7 && activeClass} label={t('admin.zaglavljePlate')} className="mt-3 zaposleniShift adminTab" onClick={() => setChangeView(7)} />

            {changeView === 1 && (
                <BonusiTab
                    options={options}
                    bonusiDB={bonusiDB}
                    onRefresh={fetchInit}
                    toast={toast}
                />
            )}
            {changeView === 2 && (
                <KilometriTab
                    options={options}
                    kilometriDB={kilometriDB}
                    onRefresh={fetchInit}
                    toast={toast}
                />
            )}
            {changeView === 3 && (
                <DnevniceObracunTab
                    options={options}
                    dnevniceDB={dnevniceDB}
                    onRefresh={fetchInit}
                    toast={toast}
                />
            )}
            {changeView === 4 && (
                <MinimalnaZaradaTab
                    minimalnaZaradaDB={minimalnaZaradaDB}
                    zaposleniDB={zaposleniDB}
                    options={options}
                    onRefresh={fetchInit}
                    toast={toast}
                />
            )}
            {changeView === 5 && (
                <AdminZabraneTab
                    adminZabraneDB={adminZabraneDB}
                    zaposleniDB={zaposleniDB}
                    options={options}
                    onRefresh={fetchInit}
                    toast={toast}
                />
            )}
            {changeView === 6 && (
                <AmortizacijaTab
                    options={options}
                    amortizacijaDB={amortizacijaDB}
                    onRefresh={fetchInit}
                    toast={toast}
                />
            )}
            {changeView === 7 && (
                <ObracunPlateZaglavljeTab
                    valuteDB={zaglavljeValuteDB}
                    stavkeDB={zaglavljeStavkeDB}
                    nacinDB={zaglavljeNacinDB}
                    tipDB={zaglavljeTipDB}
                    onRefresh={fetchZaglavljeInit}
                    toast={toast}
                />
            )}
        </div>
    );
};

export default ObracunTuraHome;
